<template>
    <main class="landing-page">
        <LoadingCommon v-if="isLoadingScreen" />
        <div class="game-fafi" v-else>
            <div class="game-fafi__item info">
                <img
                    class="image-banner"
                    :src="
                        require(`@/public/theme/default/img/${
                            $store.state.accountSetting.base_skin || 'default'
                        }/banner.png`)
                    "
                />
                <GameAbouts v-if="!$store.state.isMobile" :listAbouts="listAbouts" />
            </div>
            <div class="game-fafi__item content">
                <GameComponent :listNumber="listNumber" />
            </div>
            <div class="game-fafi__item c-betslip">
                <Betslip :listNumber="listNumber" />
                <img
                    class="image-banner"
                    :src="
                        require(`@/public/theme/default/img/${
                            $store.state.accountSetting.base_skin || 'default'
                        }/banner-betslip.png`)
                    "
                />
            </div>
            <template v-if="$store.state.isMobile">
                <img
                    class="image-banner"
                    :src="
                        require(`@/public/theme/default/img/${
                            $store.state.accountSetting.base_skin || 'default'
                        }/banner-betslip.png`)
                    "
                />
                <GameAbouts :listAbouts="listAbouts" />
            </template>
        </div>
    </main>
</template>
<script>
import GameComponent from '@/components/games/index.vue'
import GameAbouts from '@/components/abouts/index.vue'
import Betslip from '@/components/betslip/index.vue'
import gamesService from '@/services/games.service'
import LoadingCommon from '@/components/common/loading.vue'
const IS_DEV = process.env.VUE_APP_DEV

export default {
    components: { GameComponent, GameAbouts, Betslip, LoadingCommon },
    data() {
        return {
            listNumber: [],
            listAbouts: [],
            isLoadingScreen: true,
        }
    },
    created() {
        this.fetchData()
        this.handleResize()
        window.addEventListener('resize', this.handleResize)
    },
    methods: {
        async fetchData() {
            try {
                const resp = await gamesService.getListGames()
                const listAbouts = []
                for (let i = 0; i < resp.data.length; i += 10) {
                    listAbouts.push(resp.data.slice(i, i + 10))
                }
                this.$store.state.gameLength = resp.data.length
                this.listAbouts = listAbouts
                this.listNumber = resp.data
                this.isLoadingScreen = false
            } catch (error) {
                if (parseInt(IS_DEV)) {
                    console.log(error)
                }
            }
        },

        handleResize() {
            if (window.innerWidth <= 768) {
                this.$store.state.isMobile = true
            } else {
                this.$store.state.isMobile = false
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/home/index.scss';
</style>
